import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Card, H3, H6, Button, Classes, Intent, ProgressBar, FormGroup, InputGroup } from '@blueprintjs/core';
import { CORPUS_TYPES } from '../constants';
import CorpusHeader from '../common/CorpusHeader';
import SavedCorpusTable from './SavedCorpusTable';
import { Dialog } from '@blueprintjs/core';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants';
import { Tooltip2 } from '@blueprintjs/popover2';

//import { refreshSignIn } from '../../../utils'


class SavedCorpus extends React.PureComponent {

  state = {
    selectedCorpus: null,
    isOpenModal: false,
    waitingForVocExtraction:false,
    waitingForCsvStats:false,
    filter:"",
  };

  toggleModal = () => {
    this.setState(prevState => ({ isOpenModal: !prevState.isOpenModal }));
  }

  handleSelectionReady = () => {
    this.props.onSavedCorpusChosen(this.state.selectedCorpus.json.name,this.state.selectedCorpus.json.language,this.state.constrastCorpus,this.state.savedConstrastCorpus);
  }

  handleSelectRow = (selectedCorpus) => {
    this.setState({ selectedCorpus: selectedCorpus });
  }


  openVocPage=()=>{
    const { selectedCorpus } = this.state;
    const savedCorpus = {
      type: CORPUS_TYPES.SAVED,
      language: selectedCorpus.json.language,
      name: [selectedCorpus.json.name],
    };
    this.props.onDescriptionQuery('__voc__',savedCorpus);
  };

  openCollocPage=()=>{
    const { selectedCorpus } = this.state;
    const savedCorpus = {
      type: CORPUS_TYPES.SAVED,
      language: selectedCorpus.json.language,
      name: [selectedCorpus.json.name],
    };
    this.props.onDescriptionQuery('__colloc__',savedCorpus);
  };

  openMetaPage=()=>{
    const { selectedCorpus } = this.state;
    const savedCorpus = {
      type: CORPUS_TYPES.SAVED,
      language: selectedCorpus.json.language,
      name: [selectedCorpus.json.name],
    };
    this.props.onDescriptionQuery('__meta__',savedCorpus);
  };

  handleOnConfirmSuppressCorpus =() => {
    this.toggleModal();
    const endpoint = '/delete_files.ajax.php';

    const data={ 
      type:'corpus',
      name:[this.state.selectedCorpus.json.name],
      language:this.state.selectedCorpus.json.language,
      nbToks:this.state.selectedCorpus.json.nbToks
    };

    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((data) => {
          this.props.refreshSavedData();
          this.setState({ selectedCorpus: null });
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
  };

  handleSplitDD =() => {
    const endpoint = '/splitDD.ajax.php';

    const data={ 
      // type:'corpus',
      name:this.state.selectedCorpus.json.name,
      language:this.state.selectedCorpus.json.language,
    };

    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((data) => {
          if (data.splitted) {
            const newSelectedCorpus=this.state.selectedCorpus;
            newSelectedCorpus.json.splitDD=true;
            console.log(newSelectedCorpus);
            this.setState({ selectedCorpus:newSelectedCorpus});
            this.props.refreshSavedData();
          } else {
            console.log(`Splitting of DD failed`);
          }
        });
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
  };

  handleOnExtractVocCollig =() => {
    const endpoint = '/extractVocCollig.ajax.php';

    const data={ 
      // type:'corpus',
      name:this.state.selectedCorpus.json.name,
      language:this.state.selectedCorpus.json.language,
    };

    this.setState({'waitingForVocExtraction':true});
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          this.setState({'waitingForVocExtraction':false});
          return;
        }
        res.json().then((data) => {
          if (data.vocFile) {
            const newSelectedCorpus=this.state.selectedCorpus;
            newSelectedCorpus.json.vocFile=data.vocFile;
            newSelectedCorpus.json.collocFile=data.collocFile;
            console.log(newSelectedCorpus);
            this.setState({ selectedCorpus:newSelectedCorpus,'waitingForVocExtraction':false});
            this.props.refreshSavedData();
          } else {
            console.log(`Voc extraction failed`);
          }
        });
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
        this.setState({'waitingForVocExtraction':false});
      })
  };

  handleOnExtractCsvStats =() => {
    const endpoint = '/extractCsvStats.ajax.php';

    const data={ 
      // type:'corpus',
      name:this.state.selectedCorpus.json.name,
      language:this.state.selectedCorpus.json.language,
    };

    this.setState({'waitingForCsvStats':true});
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          this.setState({'waitingForCsvStats':false});
          return;
        }
        res.json().then((data) => {
          if (data.csvStatsFile) {
            const newSelectedCorpus=this.state.selectedCorpus;
            newSelectedCorpus.summary.csvStatsFile=data.csvStatsFile;
            console.log(newSelectedCorpus);
            this.setState({ selectedCorpus:newSelectedCorpus,'waitingForCsvStats':false});
            this.props.refreshSavedData();
          } else {
            console.log(`Stats extraction failed`);
          }
        });
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
        this.setState({'waitingForVocExtraction':false});
      })
  };


  render() {
    const { selectedCorpus, isOpenModal,waitingForVocExtraction,waitingForCsvStats } = this.state;
    const { t, savedCorpora, tokenCredit } = this.props;
    const selectedLanguage=selectedCorpus? selectedCorpus.json.language:"";
    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";

    const items=[];
    if (selectedCorpus) {
      //console.log(selectedCorpus.summary);
      for (const key of Object.keys(selectedCorpus.summary).sort()) {
        if (selectedCorpus.summary[key] && key!=="processLog" && key!=="status") { 
          items.push(
            <li key={key}>{key} : {selectedCorpus.summary[key].toString()}</li>
          );
        }
      }
    }
    
    const collsInSelectedLang = selectedCorpus && selectedLanguage && this.props.collections[selectedLanguage] ? this.props.collections[selectedLanguage]:{};
    const collNamesInSelectLang = Object.keys(collsInSelectedLang);
    const savedCorporaInSelectLang = savedCorpora ? savedCorpora.filter( savedCorpus => (savedCorpus.json.language === selectedLanguage && savedCorpus !== selectedCorpus)).map(savedCorpus => savedCorpus.json.name):[];
    const processLog=selectedCorpus && selectedCorpus.summary && selectedCorpus.summary.processLog ? <p dangerouslySetInnerHTML={{__html:selectedCorpus.summary.processLog.replace("\n","<br/>")}}></p> : "";

    return (
      <>
        <CorpusHeader
          title={t('savedCorpusHeader')}
          goToQuery={this.handleSelectionReady}
          ready={!! selectedCorpus }
          explanations={selectedCorpus? selectedCorpus.file:""}
        />
        <H6>{t('tokenCreditColon')} {Intl.NumberFormat(langFormat).format(tokenCredit)}</H6>
        <FormGroup 
          label={t('filter')} 
          labelFor="filter" 
          inline={true}
          helperText={t('filterHelp')}
        >
          <InputGroup
            id="filter"
            value={this.state.filter}
            onChange={(e) => this.setState({ filter: e.target.value })}
          />
        </FormGroup>
        <div className="flex">

          <div className="flex-two-panels">
            <div className="padding-1-rem">
              {savedCorpora &&
                <SavedCorpusTable
                  savedCorpora={savedCorpora}
                  onSelectRow={this.handleSelectRow}
                  filter={this.state.filter}
                  csvDelimiter={this.props.csvDelimiter}
                />
              }
            </div>
          </div>
          <div className="flex-two-panels">
            <div className="padding-1-rem">
              {selectedCorpus &&
                <Card elevation={2}>
                  {selectedCorpus.summary.status && selectedCorpus.summary.status!=="Done" &&
                    <>
                      <Tooltip2 minimal={false} intent="primary" className={Classes.TOOLTIP_INDICATOR} content={processLog}>
                        <p>{t('followImportationSteps')}</p>
                      </Tooltip2>
                      <ProgressBar />
                      <br/>
                    </>

                  }
                  <H3 className="margin-bottom-1-5rem">{selectedCorpus.file}</H3>
                  <H6>{t('recapInfo')}</H6>
                  <ul>
                    {items}
                  </ul>
                  {selectedCorpus.xml &&
                    <p>
                      <a href={selectedCorpus.xml}>{t('link2xmlFile')}</a><br/>
                    </p>
                  }
                  {selectedCorpus.summary.csvVocFile &&
                    <p>
                      <a href={process.env.REACT_APP_API_BASE+selectedCorpus.summary.csvVocFile}>{t('link2csvVocFile')}</a><br/>
                    </p>
                  }
                  {selectedCorpus.summary.csvStatsFile &&
                    <p>
                      <a href={process.env.REACT_APP_API_BASE+selectedCorpus.summary.csvStatsFile}>{t('link2csvStatsFile')}</a><br/>
                    </p>
                  }  

                  <br/>
                  
                  {selectedCorpus.json.vocFile && 
                    // TODO ici bizarrement l'affichage ne se raffraichit pas après avoir lancé le calcul extractVocCollig
                    <>
                      <Button onClick={this.openVocPage}>{t('vocabulary')}</Button>
                      &nbsp;&nbsp;
                      <Button onClick={this.openCollocPage}>{t('collocCollig')}</Button> 
                      &nbsp;&nbsp;
                      
                    </>
                  }
                  {selectedCorpus.json.markedDD && ! selectedCorpus.json.splitDD && 
                    // TODO ici bizarrement l'affichage ne se raffraichit pas après avoir lancé le calcul extractVocCollig
                    <>
                      <Button onClick={this.handleSplitDD}>{t('splitDD')}</Button>
                      &nbsp;&nbsp;
                    </>
                  }
                  { typeof selectedCorpus.json.vocFile == 'undefined' && (! selectedCorpus.summary.status || selectedCorpus.summary.status==="Done" ) &&
                    <>
                      <Button onClick={this.handleOnExtractVocCollig}>{t('extractVocCollig')}</Button>
                      &nbsp;&nbsp;
                      { waitingForVocExtraction && < ProgressBar /> }
                    </>
                  }
                  { typeof selectedCorpus.summary.csvStatsFilevocFile == 'undefined' && (! selectedCorpus.summary.status || selectedCorpus.summary.status==="Done" ) &&
                    <>
                      <Button onClick={this.handleOnExtractSimpleStats}>{t('extractCsvStats')}</Button>
                      &nbsp;&nbsp;
                      { waitingForCsvStats && < ProgressBar /> }
                    </>
                  }

                  <Button onClick={this.openMetaPage}>{t('metadata')}</Button> 
                  &nbsp;&nbsp;
                  
                  {selectedCorpus.file !== 'last_corpus.json' &&
                    <Button text={t('suppress')} intent="danger" onClick={this.toggleModal} />
                  }
                  <p></p>
                  <H6>{t('choseConstrastCorpusColon')}</H6>
                  <EnhancedSingleSelect
                    hasDefault={true}
                    hasSelectableDefault={true}
                    label={t('predefinedCorpus')}
                    name={"collection"}
                    options={collNamesInSelectLang}
                    onChange={(e)=>{this.setState({constrastCorpus:e.target.value})}}
                    popoverProps={{ minimal: true }}
                  />

                  <EnhancedSingleSelect
                    hasDefault={true}
                    hasSelectableDefault={true}
                    label={t('savedCorpusHeader')}
                    name={"savedContrastcorpus"}
                    options={savedCorporaInSelectLang}
                    onChange={(e)=>{this.setState({savedConstrastCorpus:e.target.value})}}
                    popoverProps={{ minimal: true }}
                  />

                </Card>
              }
            </div>
          </div>
        </div>
       
        {selectedCorpus &&
          <Dialog
            isOpen={isOpenModal}
            onClose={this.toggleModal}
            title={t('suppress')+" «"+selectedCorpus.file+"»"}
            style={{'width': '400px'}}  // 400px seems a good deal
          >
            <div className={Classes.DIALOG_BODY}>
              {t('suppressCorpusExplanation')}
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>

                <Button onClick={this.toggleModal}>Close</Button>

                <Button
                    onClick={this.handleOnConfirmSuppressCorpus}
                    intent={Intent.DANGER}
                >
                    {t('confirmSuppressing')}
                </Button>
              </div>
            </div>

          </Dialog>
        }
      </>
    );
  }
}

SavedCorpus.propTypes = {
  onSavedCorpusChosen: PropTypes.func,
  onDescriptionQuery: PropTypes.func,
  tokenCredit: PropTypes.number,
  savedCorpora: PropTypes.array,
  collections: PropTypes.object,
  refreshSavedData: PropTypes.func,
  csvDelimiter: PropTypes.string,
};

export default withTranslation()(SavedCorpus);
